import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { UserApi } from "../api/user.api";
import { Observable } from "rxjs";
import { EmailRecipientFilterService } from "./filter.service";
import { HttpClient } from "@angular/common/http";
import { EmailRecipient } from "../models/email-recipient";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class RecipientService {
  public filter: EmailRecipientFilterService;
  public editing: EmailRecipient;

  public recipients$: Observable<EmailRecipient[]>;

  constructor(public db: AngularFirestore, public httpClient: HttpClient) {
    this.filter = new EmailRecipientFilterService();
    this.observe();
    this.subscribe();
  }

  observe() {
    this.recipients$ = this.db
      .collection("devEmailRecipients")
      .snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(action => {
            var data = action.payload.doc.data();
            const id = action.payload.doc.id;
            return new EmailRecipient(data, id);
          });
        })
      );
  }
  subscribe() {
    this.recipients$.subscribe(recips => this.filter.next(recips));
  }

  async create(info: {}) {
    await this.db.collection("devEmailRecipients").add(info);
  }
  search = (text: string) => this.filter.search(text);

  async edit(recip: EmailRecipient) {
    this.editing = recip;
  }

  get isEditing(): boolean {
    return this.editing != null;
  }

  async updateRecipient() {
    let id = this.editing.id;
    await this.db
      .collection("devEmailRecipients")
      .doc(id)
      .update(this.editing.toJSON());
    return;

    //Update info in editing variable, then push to DB
  }

  async delete() {
    let id = this.editing.id;
    await this.db
      .collection("devEmailRecipients")
      .doc(id)
      .delete();
    this.editing = null;
    return;
  }
}
